import { Investments } from '../../FinancesByFy/FinancesByFyProps';
import { InvestmentItem } from '../../../models/project';
import { v4 as uuidv4 } from 'uuid';
import { getFyNumber } from '../../../utils/calculation';

export const createEmptyInvestmentItem = (
  fiscalYear: string,
): Partial<InvestmentItem> => ({
  fiscalYear: fiscalYear,
  landCost: null,
  retailCost: null,
  propertyInvestment: null,
  retailInvestment: null,
});

export const createEmptyFiscalYear = (fiscalYear: string): Investments => ({
  id: uuidv4(),
  fiscalYear: fiscalYear,
  FORECAST: createEmptyInvestmentItem(fiscalYear),
  SUBMITTED_FORECAST: null,
  BASELINE: null,
  RELEASED_APPROVED_BUDGET: createEmptyInvestmentItem(fiscalYear),
  BUDGET: createEmptyInvestmentItem(fiscalYear),
});
export const extendFiscalYears = (
  originalData: Investments[],
  startYear: number,
  endYear: number,
): Investments[] => {
  const targetFiscalYears: string[] = [];
  const defaultAdditionalFinancialYears = 3;

  for (
    let year = startYear;
    year <= endYear + defaultAdditionalFinancialYears;
    year++
  ) {
    targetFiscalYears.push(`FY${year.toString().slice(-2)}`);
  }

  const originalDataMap: { [key: string]: Investments } = {};
  originalData.forEach((entry) => {
    originalDataMap[entry.fiscalYear] = entry;
  });
  let finalData;
  if (targetFiscalYears.length < originalData.length) {
    finalData = originalData.filter((entry) =>
      targetFiscalYears.includes(entry.fiscalYear),
    );
  } else {
    finalData = targetFiscalYears.map((fiscalYear) => {
      return originalDataMap[fiscalYear] || createEmptyFiscalYear(fiscalYear);
    });
  }
  return finalData.sort(
    (a, b) => getFyNumber(a.fiscalYear) - getFyNumber(b.fiscalYear),
  );
};
